import {
  POST_FOLLOW_CALL_ORDERS_ORDER_REQUEST,
  POST_FOLLOW_CALL_ORDERS_ORDER_SUCCESS,
  POST_FOLLOW_CALL_ORDERS_ORDER_FAILURE,
  GET_FOLLOW_CALL_ORDER_LIST_REQUEST,
  GET_FOLLOW_CALL_ORDER_LIST_SUCCESS,
  GET_FOLLOW_CALL_ORDER_LIST_FAILURE,
  POST_FOLLOW_CALL_ORDERS_SALESFORCE_SYNC_REQUEST,
  POST_FOLLOW_CALL_ORDERS_SALESFORCE_SYNC_SUCCESS,
  POST_FOLLOW_CALL_ORDERS_SALESFORCE_SYNC_FAILURE,
} from "../../constants/ActionTypes";
import { FollowCallOrdersApi } from "../api/FollowCallOrdersApi";
import { push } from "react-router-redux";
import { resolveOrderConnectionErrorMessage } from "../../utils/orderErrorUtils";

/*** POST /follow-call-orders/order ***/
const postFollowCallOrdersOrderRequest = () => ({
  type: POST_FOLLOW_CALL_ORDERS_ORDER_REQUEST,
});

const postFollowCallOrdersOrderSuccess = (data) => ({
  type: POST_FOLLOW_CALL_ORDERS_ORDER_SUCCESS,
  payload: {
    data: data,
  },
});

const postFollowCallOrdersOrderFailure = (error, message = null) => ({
  type: POST_FOLLOW_CALL_ORDERS_ORDER_FAILURE,
  payload: {
    error: error,
    message: message,
  },
});

export function postFollowCallOrdersOrder(params = {}) {
  return async (dispatch) => {
    dispatch(postFollowCallOrdersOrderRequest());

    FollowCallOrdersApi.postFollowCallOrdersOrder(params.data, dispatch)
      .then((response) => {
        dispatch(postFollowCallOrdersOrderSuccess(response.data.data));
        if (params && params.id) {
          dispatch(
            push(
              `/house-list/${params.id}/timeline`, {
              followCallOrderComplete: true,
            })
          );
        } else {
          dispatch(
            push(`/order-dashboard`, {
              followCallOrderComplete: true,
            })
          );
        }
      })
      .catch((error) => {
        const errorResponse = error ? error.response : undefined;

        dispatch(
          postFollowCallOrdersOrderFailure(
            errorResponse,
            resolveOrderConnectionErrorMessage(errorResponse)
          )
        );
      });
  };
}

/***  GET /follow-call-orders ***/
const getFollowCallOrderListRequest = (overwrite) => ({
  type: GET_FOLLOW_CALL_ORDER_LIST_REQUEST,
  payload: {
    overwrite: overwrite,
  }
});

const getFollowCallOrderListSuccess = (data, pageInfo, overwrite) => ({
  type: GET_FOLLOW_CALL_ORDER_LIST_SUCCESS,
  payload: {
    data: data,
    pageInfo: pageInfo,
    overwrite: overwrite,
  }
});

const getFollowCallOrderListFailure = (error) => ({
  type: GET_FOLLOW_CALL_ORDER_LIST_FAILURE,
  payload: {
    error: error
  }
});

export function getFollowCallOrderList(data, overwrite) {
  return async (dispatch) => {
    dispatch(getFollowCallOrderListRequest(overwrite));

    FollowCallOrdersApi.getFollowCallOrders(data, dispatch)
      .then((response) => {
        dispatch(getFollowCallOrderListSuccess(
          response.data.data,
          response.data.meta,
          overwrite
        ));
      })
      .catch((error) => {
        dispatch(getFollowCallOrderListFailure(error.response));
      });
  };
}

/*** POST /follow-call-orders/salesforce/sync ***/
const postFollowCallOrdersSalesforceSyncRequest = () => ({
  type: POST_FOLLOW_CALL_ORDERS_SALESFORCE_SYNC_REQUEST,
});

const postFollowCallOrdersSalesforceSyncSuccess = () => ({
  type: POST_FOLLOW_CALL_ORDERS_SALESFORCE_SYNC_SUCCESS,
});

const postFollowCallOrdersSalesforceSyncFailure = (error) => ({
  type: POST_FOLLOW_CALL_ORDERS_SALESFORCE_SYNC_FAILURE,
  payload: {
    error: error
  }
});

export function postFollowCallOrdersSalesforceSync(data) {
  return async (dispatch) => {
    dispatch(postFollowCallOrdersSalesforceSyncRequest());

    FollowCallOrdersApi.postFollowCallOrdersSalesforceSync(data, dispatch)
      .then(() => {
        dispatch(postFollowCallOrdersSalesforceSyncSuccess());
      })
      .catch((error) => {
        dispatch(postFollowCallOrdersSalesforceSyncFailure(error.response));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/FollowCallOrder.js